import { render, staticRenderFns } from "./CreateRemittanceUST.vue?vue&type=template&id=401c2e2d&"
import script from "./CreateRemittanceUST.vue?vue&type=script&lang=ts&"
export * from "./CreateRemittanceUST.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports